
import Vue from 'vue';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Button,
} from 'element-ui';
import api from '@/api/match';
import tEditor from '@/components/Editor/editor.vue';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Button,
  },
})

export default class thirdStep extends Vue {
  @Prop({
    required: false,
    default: '添加赛事内容',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  private toolbarOptions: any = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }],
    [{ background: [] }],
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ direction: 'rtl' }],
    [{ size: ['10px', false, '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px'] }],
    [{ font: ['serif', 'monospace', 'Microsoft YaHei'] }],
    [{ align: [] }],
    ['clean'],
    ['link', 'image'],
  ];

  private form: { content: string, pid?: string } = {
    content: '',
  };

  private rules: any = {
    content: [
      { required: true, message: '请填写赛事内容', trigger: 'blur' },
    ],
  }

  private loading: boolean = false;

  public $refs!: {
    form: Form,
    tEditor: tEditor,
  };

  mounted() {
    this.form.pid = this.oldForm.pid;
    if (this.title.includes('编辑')) {
      this.form.content = this.oldForm.content;
    }
  }

  /**
   * @author liangyongmou
   * @desc  富文本编辑器内容改变事件
   * @param { content } 富文本编辑器内容
   */
  contentChange(content: string) {
    this.$set(this.form, 'content', content);
  }

  /**
   * @author liangyongmou
   * @desc 添加/修改赛事内容
   * @param { string } title 标题
   */
  handleSubmit() {
    this.loading = true;
    let form:{ content?: string, pid?: string } = {};
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        const { content, pid } = this.form;
        form = { content, pid };
      }
    });
    return form;
  }

  /**
   * @author liangyongmou
   * @desc 重置赛事内容
   * @param { boolean } close 是否关闭模态框
   * @param { boolean } refrsh 是否点击重置按钮
   */
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    if (this.title.includes('修改')) {
      this.$refs.tEditor.refresh();
      this.form = this.oldForm;
    } else this.$refs.tEditor.refresh();
  }

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }
}
